import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  const featuredArticle = articles.find((a) => a.slug === 'dingji-wanghong-zhibo-fanche-mingmianchang') || articles[0];

  return (
    <section className="relative h-[500px] md:h-[650px] flex items-end">
      <img
        src="https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20scene%20with%20abstract%20%20crimson%20and%20dark%20toned%20background%2C%20dynamic%20light%20streaks%2C%20journalism%20atmosphere%2C%20bold%20editorial%20style%2C%20modern%20media%20concept%2C%20high%20energy%2C%20cinematic%20lighting%20with%20deep%20shadows&width=1920&height=1080&seq=chigua-hero-bg&orientation=landscape"
        alt="吃瓜官网 - 最新爆料背景"
        title="吃瓜官网 - 51吃瓜官网全网最新入口"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/70"></div>

      <div className="relative z-10 w-full mx-auto px-4 md:px-6 pb-12 md:pb-16">
        <div className="max-w-4xl">
          <div className="flex items-center gap-2 mb-3">
            <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold animate-pulse">
              <i className="ri-flashlight-line"></i> 突发爆料
            </span>
            <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
              <i className="ri-fire-line"></i> 热门
            </span>
          </div>
          <Link to={`/article/${featuredArticle.slug}`} className="cursor-pointer">
            <h1 className="font-heading font-black text-2xl md:text-4xl lg:text-5xl text-white mb-3 leading-tight hover:text-primary-300 transition-colors">
              {featuredArticle.title}
            </h1>
          </Link>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mb-4 line-clamp-2">
            {featuredArticle.excerpt}
          </p>
          <div className="flex items-center gap-4 text-white/50 text-xs">
            <span><i className="ri-user-line mr-1"></i>{featuredArticle.author}</span>
            <span><i className="ri-calendar-line mr-1"></i>{featuredArticle.publishedAt}</span>
            <span><i className="ri-time-line mr-1"></i>{featuredArticle.readTime}</span>
            <span><i className="ri-eye-line mr-1"></i>{(featuredArticle.viewCount / 10000).toFixed(0)}万阅读</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}